import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';

export const RepairReasonsCacheContext = React.createContext<ICacheContext<string[]>>(undefined as any);
